import React from "react";
import { BRAND } from "@/data";

const WORDS = ["ROOFING", "LANDSCAPING", "GROUNDWORKS", "DRAINAGE", "FENCING", "PAVING"];

export default function Marquee() {
  const sequence = [...WORDS, ...WORDS];
  return (
    <section
      className="relative z-10 bg-[#14171A] py-10 md:py-16 border-y border-[#A8AEB2]/15 overflow-hidden"
      data-testid="marquee-section"
      aria-label={BRAND.subline}
    >
      <div className="marquee-track">
        {sequence.map((word, i) => (
          <span key={i} className="inline-flex items-center">
            <span
              className={`font-display uppercase text-[14vw] md:text-[9rem] leading-none px-8 ${
                i % 2 === 0 ? "text-white" : "marquee-outline"
              }`}
            >
              {word}
            </span>
            <span className="text-[#7AB648] text-4xl md:text-6xl px-4">•</span>
          </span>
        ))}
      </div>
    </section>
  );
}
